import { gql } from '@apollo/client';

/**
 * Logging a call (card 21, on card 16's API): CRM_CONTACT_QUERY_FRONTEND.md §18
 * and §25 in ilbp-backend. Fields are written out in each document, not shared
 * as fragments: the tests run without __typename (CLAUDE.md).
 */

/**
 * One call. Closes the person's open follow-up, moves their call counters, and
 * releases any queue claim on them. Refused for an outbound call to someone
 * marked do not call or do not contact (CRM_CONTACT_DO_NOT_CALL).
 */
export const CRM_LOG_CALL = gql`
  mutation CrmLogCall($input: CrmLogCallInput!) {
    crmLogCall(input: $input) {
      id
      contactId
      outcome
      direction
      durationSec
      occurredAt
      followUpAt
      setDoNotCall
    }
  }
`;

/** Closes a follow-up without calling: they wrote back, or someone saw them. Any admin; again is harmless. */
export const CRM_COMPLETE_FOLLOW_UP = gql`
  mutation CrmCompleteFollowUp($callId: Int!) {
    crmCompleteFollowUp(callId: $callId) {
      id
      followUpOpen
      followUpDoneAt
    }
  }
`;
